import styled from 'styled-components'

const ArticleItems = styled.div`
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: 0px;
    left: 20px;
    right: 20px;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.06);
  }
`

export default ArticleItems